<template>
  <span v-if="infoTooltip" v-tooltip :title="$t(infoTooltip)" class="atom-info align-self-left mt-1 ml-1">
    <img class="mr-1" src="@/assets/icons/ico-ico-i.svg" />
  </span>
</template>

<script>
export default {
  props: {
    infoTooltip: {
      type: String,
      required: true
    }
  }
}
</script>
